module.exports = __webpack_public_path__ + "img/iccCard.620f1c30.png";